if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }

      toggleSubmitButton(disable = true, text) {
  if (disable) {
    this.submitButton.setAttribute('disabled', 'disabled');

    if (text) {
      this.submitButtonText.textContent = text;
    }
  } else {
    this.submitButton.removeAttribute('disabled');

    const preorderEnabled =
      this.submitButton.dataset.preorderEnabled === 'true';

    const inventoryQty = Number(
      this.submitButton.dataset.inventoryQuantity || 0
    );

    const inventoryPolicy =
      this.submitButton.dataset.inventoryPolicy;

    if (
      preorderEnabled &&
      inventoryQty <= 0 &&
      inventoryPolicy === 'continue'
    ) {
      this.submitButtonText.textContent =
        window.variantStrings.preorder || 'Vorbestellen';
    } else {
      this.submitButtonText.textContent =
        window.variantStrings.addToCart;
    }
  }
}

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        // TB-Check (z. B. Mindestmengen etc.)
        let tb_required = false;
        if (window.tb_check_min_max) {
          let minmax = tb_check_min_max(true);
          if (minmax) {
            tb_required = true;
          }
        }

        // TB Required Fields
        document.querySelectorAll('[data-tb-app-fields="true"]').forEach((e) => {
          if (e.required && !e.value && e.display !== 'none' && e.scrollHeight) {
            let id = e.id.split('_')[1];
            if(document.querySelector(`#alertBox_${id}`)){
              document.querySelector(`#alertBox_${id}`).style.display = 'block';
            }
            tb_required = true;
          }
        });

        if (tb_required) return;
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            console.log("RESP", response);
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              // Fallback: Weiterleitung zum Warenkorb
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            }

            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              console.log("THIS", this, response);
              this.cart.renderContents(response);
              if (typeof this.cart.open === 'function') {
                this.cart.open();
              } else {
                this.cart.classList.add('open');
                document.body.classList.add('drawer-open');
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }
    }
  );
}
